



















































































































































































































import env from "@/utils/env";
import TinyEditor from "@tinymce/tinymce-vue";
import Multiselect from "vue-multiselect";
import { Component, Vue } from "vue-property-decorator";
import {
  Debtors,
  PaymentTerms,
  Currencys,
  InvoiceTemplates,
  EmailTemplate,
  Payment,
} from "@/types/invoices";

@Component({
  name: "ManualInvoice",
  components: {
    Multiselect,
    TinyEditor,
  },
})
export default class ManualInvoice extends Vue {
  private env = env;
  private tinyEditorInit = {
    height: 400,
    menubar: false,
    plugins: [
      "advlist autolink lists link image charmap print preview anchor",
      "searchreplace visualblocks code fullscreen",
      "insertdatetime media table paste code help wordcount",
      "image",
    ],
    toolbar:
      "fontselect fontsizeselect formatselect | bold italic underline strikethrough |  forecolor backcolor | bullist numlist outdent indent | image | alignleft aligncenter alignright alignjustify ",
  };
  private debtors: Debtors = {
    debtorSelected: { id: 1, name: "debtor-1" },
    debtorOptions: [
      { id: 1, name: "debtor-1" },
      { id: 2, name: "debtor-2" },
    ],
  };
  private invoiceNumber = 696969;
  private paymentTerms: PaymentTerms = {
    paymentTermsSelected: { id: 1, name: "paymentTerms-1" },
    paymentTermsOptions: [
      { id: 1, name: "paymentTerms-1" },
      { id: 2, name: "paymentTerms-2" },
    ],
  };
  private payments: Payment[] = [];
  private newID = 0;
  private currencys: Currencys = {
    currencysSeleted: { name: "EUR" },
    currencysOptions: [{ name: "EUR" }, { name: "USD" }, { name: "VND" }],
  };
  private invoiceTemplates: InvoiceTemplates = {
    invoiceTemplatesSelected: { id: 1, name: "invoiceTemplates-1" },
    invoiceTemplatesOptions: [
      { id: 1, name: "invoiceTemplates-1" },
      { id: 2, name: "invoiceTemplates-2" },
    ],
  };
  private emailTemplate: EmailTemplate = {
    emailTemplateSelected: { id: 1, name: "emailTemplate-1" },
    emailTemplateOptions: [
      { id: 1, name: "emailTemplate-1" },
      { id: 2, name: "emailTemplate-2" },
    ],
  };
  private emailSubject = "Invoice: [invoice-number]";
  private emailContent = "";
  private showModalDiscardInvoice = false;
  private showModalSendInvoice = false;

  get total() {
    const total = this.payments.reduce((total, currentPayment) => {
      total +=
        currentPayment.amount +
        (currentPayment.amount * currentPayment.vat) / 100;
      return total;
    }, 0);

    return total;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onReady(editor: any) {
    // Insert the toolbar before the editable area.
    editor.ui
      .getEditableElement()
      .parentElement.insertBefore(
        editor.ui.view.toolbar.element,
        editor.ui.getEditableElement()
      );
  }

  searchDebtor(keyword: string) {
    console.log({ keyword });
  }

  inputDebtor(debtorSelected: object) {
    console.log({ debtorSelected });
  }

  addNewPayment() {
    this.payments.push({
      id: this.newID,
      amount: 0,
      vat: 0,
      description: "",
    });
    this.newID += 1;
  }

  deletePayment(id: number) {
    const indexPayment = this.payments.findIndex(
      (payment) => payment.id === id
    );
    if (indexPayment === -1) return;
    this.payments.splice(indexPayment, 1);
  }

  previewInvoiceTemplate() {
    console.log(this.emailContent);

    console.log("previewInvoiceTemplate");
  }

  toggleModalDiscardInvoice() {
    this.showModalDiscardInvoice = !this.showModalDiscardInvoice;
  }

  noDiscardInvoice() {
    this.toggleModalDiscardInvoice();
  }

  yesDiscardInvoice() {
    this.toggleModalDiscardInvoice();
    this.$router.push({ path: "/" });
  }

  toggleModalSendInvoice() {
    this.showModalSendInvoice = !this.showModalSendInvoice;
  }

  noSendInvoice() {
    this.toggleModalSendInvoice();
  }

  yesSendInvoice() {
    this.toggleModalSendInvoice();
  }
}
